module.exports = __webpack_public_path__ + "img/mgh-gotanda.76bea40d.jpg";